import { NormalizedScheduledLeg } from '@mopla/data-models';
import { diffInShownMinutes } from '@mopla/utils';

export type TLegTimeDeviationScope = 'departure' | 'arrival' | 'both';

export type TLegTimeDeviation = {
	/** Signed whole minutes; negative when the leg runs earlier than planned. */
	deviationMinutes: number;
	/** Which of the two times moved — picks the banner text. */
	scope: TLegTimeDeviationScope;
};

const diffOrZero = (planned?: string, estimated?: string): number =>
	planned && estimated ? diffInShownMinutes(planned, estimated) : 0;

/**
 * Deviation of a leg from its plan; null when the estimates match the plan.
 *
 * `consideredDelayed` is deliberately ignored: it encodes the distributor's
 * notification threshold, not what the driver should see.
 */
export const getLegTimeDeviation = (
	leg: NormalizedScheduledLeg
): TLegTimeDeviation | null => {
	const startDiff = diffOrZero(leg.start, leg.estimatedStart);
	const endDiff = diffOrZero(leg.end, leg.estimatedEnd);

	if (!startDiff && !endDiff) {
		return null;
	}

	return {
		/** Departure wins (matching the passenger app). */
		deviationMinutes: startDiff || endDiff,
		scope: startDiff && endDiff ? 'both' : startDiff ? 'departure' : 'arrival',
	};
};
